<template>
  <div class="page wallet">
    <pageTitle title='我的代金券' :showRight='true' @rightHandler='goRule'></pageTitle>
    <div class="subTitle">
      <mu-tabs :value="activeTab" @change="handleTabChange" id="type">
        <mu-tab value="tab1" title="未使用" />
        <mu-tab value="tab2" title="已使用" />
        <mu-tab value="tab3" title="已过期" />
        <mu-tab value="tab4" title="领取" />
        <mu-tab value="tab5" title="兑换" />
      </mu-tabs>
    </div>
    <div v-if="activeTab === 'tab1'">
      <mu-refresh-control :refreshing="refreshing[0]" :trigger="trigger" @refresh="refresh" />
      <div class="demo-refresh-container">
        <div class="vocherbg" v-for="vocher in vochers[0]">
          <div class="vocherbg_left">
            <div class="vochermain valid">
              ￥
              <span class="num">{{vocher.FaceValue}}</span>
            </div>

          </div>
          <div class="vocherbg_right">
            <h4>{{vocher.Name}}</h4>
            生效日期&nbsp;&nbsp;{{vocher.StartDate | dayDate}}<br/> 失效日期&nbsp;&nbsp;{{vocher.Enddate | dayDate}}<br/>
          </div>
        </div>
      </div>
      <loadListTail mainTitle='您目前还没有代金券哦，邀请好友注册有机会抽取代金券、免房券！' mainIcon='noVoucher' :noMore='loadState[0].stop' :isLoading='loadState[0].loading' :overZero='vochers[0].length > 0' />
      <div class='loading' v-if='loadState[0].loading'>
        <img src="../../../static/LoadingBest.gif" />
      </div>
    </div>
    <div v-if="activeTab === 'tab2'">
      <mu-refresh-control :refreshing="refreshing[1]" :trigger="trigger" @refresh="refresh" />
      <div class="demo-refresh-container">
        <div class="vocherbg" v-for="vocher in vochers[1]">
          <div class="vocherbg_left">
            <div class="vochermain invalid">
              ￥
              <span class="num">{{vocher.FaceValue}}</span>
            </div>

          </div>
          <div class="vocherbg_right used">
            <h4>{{vocher.Name}}</h4>
            生效日期&nbsp;&nbsp;{{vocher.StartDate | dayDate}}<br/> 失效日期&nbsp;&nbsp;{{vocher.Enddate | dayDate}}<br/>
          </div>
        </div>
      </div>
      <loadListTail mainTitle='您暂无已使用代金券哦！' mainIcon='noVoucher' :noMore='loadState[1].stop' :isLoading='loadState[1].loading' :overZero='vochers[1].length > 0' />
      <div class='loading' v-if='loadState[1].loading'>
        <img src="../../../static/LoadingBest.gif" />
      </div>
    </div>
    <div v-if="activeTab === 'tab3'">
      <mu-refresh-control :refreshing="refreshing[2]" :trigger="trigger" @refresh="refresh" />
      <div class="demo-refresh-container">
        <div class="vocherbg" v-for="vocher in vochers[2]">
          <div class="vocherbg_left">
            <div class="vochermain invalid">
              ￥
              <span class="num">{{vocher.FaceValue}}</span>
            </div>

          </div>
          <div class="vocherbg_right outdate">
            <h4>{{vocher.Name}}</h4>
            生效日期&nbsp;&nbsp;{{vocher.StartDate | dayDate}}<br/> 失效日期&nbsp;&nbsp;{{vocher.Enddate | dayDate}}<br/>
          </div>
        </div>
      </div>
      <loadListTail mainTitle='您暂无已过期代金券哦！' mainIcon='noVoucher' :noMore='loadState[2].stop' :isLoading='loadState[2].loading' :overZero='vochers[2].length > 0' />
      <div class='loading' v-if='loadState[2].loading'>
        <img src="../../../static/LoadingBest.gif" />
      </div>
    </div>
    <div v-if="activeTab === 'tab4'">
      <div class="receive">
        <h3>请输入您的代金券编码：</h3>
        <p><input type="text" v-model="code" /></p>
        <mu-raised-button label="领取代金券" primary @click="post" v-bind:style="{ width:'100%',height:'50px'}" />
      </div>
    </div>
    <div v-if="activeTab === 'tab5'">
      <div class="exchange">
        <h3>请选择代金券类型：</h3>
        <div class="items">
          <div v-on:click="money=10" v-bind:class="{ selected: money==10 }">
            <h3>10元</h3>
          </div>
          <div v-on:click="money=20" v-bind:class="{ selected: money==20 }">
            <h3>20元</h3>
          </div>
          <div v-on:click="money=30" v-bind:class="{ selected: money==30 }">
            <h3>30元</h3>
          </div>
        </div>
        <div class="clear"></div>
        <h3>请选择代金券兑换数量：</h3>
        <div class="items">
          <div v-on:click="num=1" v-bind:class="{ selected: num==1 }">
            <h3>1张</h3>
          </div>
          <div v-on:click="num=2" v-bind:class="{ selected: num==2 }">
            <h3>2张</h3>
          </div>
          <div v-on:click="num=3" v-bind:class="{ selected: num==3 }">
            <h3>3张</h3>
          </div>
        </div>
        <div class="tips">
          [温馨提示]电子代金券限用于998.com或APP预订抵扣，可抵扣的酒店及房型预订页面代金券栏标示为准。
        </div>
        <div class="pay" style="color:black;font-size:0.24rem">
          需支付
          <span class="money">{{num*money*10}}</span>
          <span class="unit">K币</span>
          <span class="own">当前K币：{{wallet.KCoin}}</span>
        </div>
        <mu-raised-button label="兑换代金券" primary @click="open" v-bind:style="{ width:'100%',height:'50px'}" />
        <div class="explain">
          <span style="white-space:pre"> </span>
          <span class="line"></span>
          <span style="white-space:pre"> </span>
          <span class="txt">电子代金券规则说明</span>
          <span style="white-space:pre"> </span>
          <span class="line"></span>
          <div style="font-size:0.24rem;width:6.68rem;">
            <br/> 1.会员可通过手机邮箱激活验证、格林币兑换、参加官网及APP活动等途径获取电子代金券。
            <br/> 2.每张电子代金券根据不同获取途径有效期不同，具体有效截止日期以网上会员账户界面电子代金券查询为准。
            <br/> 3.电子代金券仅限通过998.com或APP预订抵扣，可抵扣的酒店以酒店房型预订页面代金券栏标示为准。
            <br/> 4.每间夜预订限使用1张电子代金券，每间夜可抵扣限额以预订界面标示为准，代金券面额超出可抵扣限额的部分不找零。
            <br/> 5.使用电子代金券的订单不能再享受生日礼遇及其他活动优惠。
          </div>
        </div>
        <mu-dialog :open="dialog" @close="close" id="check" v-bind:style="{color:'black'}">
          <p class="blackword">K币兑换电子代金券一旦操作成功无法撤销，请确认是否操作</p>
          <div class="btngroup">
            <mu-raised-button @click="close" label="取消" />
            <mu-raised-button primary label="确认兑换" @click="kExchange" />
          </div>
        </mu-dialog>
      </div>
    </div>
    <mu-toast id="alertline" v-if="toast" :message="hintMsg" @close="hideToast" />
  </div>
</template>
<style lang="less" scoped>
@import "../../assets/theme.less";
.demo-refresh-container {
  background-color: #f1f1f1;
  padding-bottom: 10px;
}

.mu-dialog {
  margin-bottom: -48px;
}

.mu-toast {
  text-align: center;
  width: 70%;
  margin: 15%;
}

.blackword {
  color: black;
}

.btngroup {
  text-align: center;
  button {
    margin: 10px;
  }
}

.page {
  .subTitle {
    #type {
      background-color: white;
      button {
        color: @textColor;
      }
      button.mu-tab-active {
        color: @primaryColor;
      }
    }
  }
  .vocherbg {
    width: 6.91rem;
    text-align: center;
    height: 2.04rem;
    margin: 0.2rem auto 0 auto;
    .vocherbg_left {
      background-color: white;
      float: left;
      display: flex;
      display: -webkit-flex;
      height: 100%;
      border-radius: 3px;
      vertical-align: center;
      border-right: 1px dashed #f1f1f1;
      padding: 0.5em;
      .valid {
        width: 2.26rem;
        background: url(../../../static/wallet/vocher/valid.png) no-repeat;
      }
      .invalid {
        background: url(../../../static/wallet/vocher/invalid.png) no-repeat;
      }
      .vochermain {
        background-size: 100% 100%;
        font-size: 0.28rem;
        width: 2.26rem;
        height: 1.6rem;
        color: white;
        .num {
          font-size: 0.54rem;
        }
        text-align: center;
        margin: auto;
        padding-right: 0.2rem;
        line-height: 1.6rem;
      }
    }
    .used {
      background: url(../../../static/wallet/vocher/used.png) no-repeat right;
    }
    .outdate {
      background: url(../../../static/wallet/vocher/outdate.png) no-repeat right;
    }
    .vocherbg_right {
      text-align: left;
      font-size: 0.24rem;
      color: @textColor;
      width: 4.2rem;
      background-color: white;
      float: left;
      display: inline-block;
      height: 100%;
      border-radius: 8px 3px 3px 8px;
      padding: 1.5em 0 1em 1.5em;
      h4 {
        margin: 0 0 0.5em 0;
        color: @primaryBlack;
        font-size: 0.3rem;
        font-weight: 500;
      }
    }
  }
  .receive {
    h3 {
      color: @primaryBlack;
      font-size: 0.3rem;
      font-weight: 600;
    }
    padding: 0em 2em;
    input {
      border: none;
      width: 100%;
      height: 50px;
      line-height: 30px;
      font-size: 30px;
    }
    input:focus {
      box-shadow: none;
    }
  }




  .exchange {
    min-height: 500px;
    background-color: white;
    height: 100%;
    padding: 0em 2em;
    padding-top: 0em;
    border-top: 1px solid #f1f1f1;
    h3 {
      margin-bottom: 0px;
      color: @secondBlack;
      font-size: 0.3rem;
    }
    .tips {
      padding: 1em;
      background-color: #f7f7f7;
      color: @textColor;
      margin-top: 5em;
      margin-bottom: 1em;
      font-size: 0.24rem;
    }
    .pay {
      .money {
        color: @primaryOrange;
        font-size: 0.42rem;
      }
      .unit {
        color: @primaryOrange;
      }
      .own {
        float: right;
        padding-top: 10px;
        color: @textColor;
        font-size: 0.24rem;
      }
      padding-bottom: 1em;
    }
    .explain {
      padding-top: 1em;
      padding-bottom: 3em;
      h4 {
        text-align: center;
      }
      .line {
        display: inline-block;
        width: 28%;
        border-top: 1px solid #f1f1f1;
      }
      .txt {
        color: @secondBlack;
        vertical-align: middle;
        font-size: 0.24rem;
      }
    }
  }
}

.items {
  text-align: center;
  position: relative;
  div {
    margin: 0;
    float: left;
    display: flex;
    flex-wrap: wrap;
    width: 29%;
    background-color: white;
    margin: 2%;
    h3 {
      margin: 0 auto;
      color: @secondBlack;
    }
    small {
      margin: 0 auto;
    }
    border: 2px solid #ccc;
    color: black;
    border-radius: 4px;
    padding: 7px 0;
  }
  .selected {
    h3 {
      color: @primaryOrange;
    }
    color: @primaryOrange;
    border: 2px solid @primaryOrange;
    position: relative;
    background: linear-gradient(135deg, @transparent 85%, @primaryOrange 10%);
  }
  .selected:after {
    content: "√";
    color: white;
    position: absolute;
    right: 0;
    bottom: -4px;
  }
}
</style>
<script>
import api from "../../api";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import Scroll from "../../utils/loading";
import loadListTail from "../../components/loadListTail";
export default {
  data() {
    return {
      activeTab: "tab1",
      money: 10,
      num: 1,
      dialog: false,
      toast: false,
      vochers: [[], [], []],
      loadState: [
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        }
      ],
      code: "",
      hintMsg: "",
      refreshing: [false, false, false],
      trigger: null,
      type: 0
    };
  },
  components: {
    loadListTail
  },
  activated() {
    console.log(1);
    console.log(this.$route.query.activeTab);
      if (this.$route.query.activeTab != undefined )
                {
                  console.log(2);
                    this.activeTab=this.$route.query.activeTab; //获取转入参数 手机号码
                }
    this.scroll.addHandler();
  },
  deactivated() {
    this.scroll.removeHandler();
  },
  mounted() {
    this.trigger = this.$el;
    this.scroll = Scroll.Create(this, this.getData, 10, 3);
  },
  methods: {
    ...mapMutations({
      setWallet: "setG_walletInfo"
    }),
    initData() {
      //清空显示数据
      this.vochers.splice(this.type, 1, []);
      //初始化本页控制数据、分页参数
      this.scroll.refresh();
    },
    handleTabChange(val) {
      //正在加载中不允许跳转
      var oldType = this.activeTab.substring(3, 4) - 1;
      if (
        oldType < 3 &&
        (this.loadState[oldType].loading || this.refreshing[oldType])
      ) {
        return;
      }
      this.activeTab = val;
      var type = this.activeTab.substring(3, 4) - 1;
      if (type < 3) {
        this.type = type;
        this.scroll.changeType(this.type);
      }
    },
    getData(type, page) {
      var that = this;
      var type = this.type;
      var params = new this.URLSearchParam();
      params.append("pageIndex", this.pageParam[type].index);
      params.append("pageSize", 10);
      params.append("logType", type);
      return new Promise(function(resolve, reject) {
        that.$http.post(api.getCouponLog(), params.toParam()).then(res => {
          if (res.Result) {
            var temp = res.Data;
            resolve(temp.length);
            that.vochers.splice(type, 1, that.vochers[type].concat(temp));
          } else {
            resolve(null);
          }
        });
      });
    },
    post() {
      var params = new this.URLSearchParam();
      if (this.code == null || this.code == "") {
        this.hintMsg = "兑换码不能为空";
        this.showToast();
        return;
      } else {
        params.append("couponCode", this.code);
        this.$http
          .post(api.exchangeCouponByCouponCode(), params.toParam())
          .then(res => {
            if (res.Result) {
              var temp = res.Data;
              //刷新数据
              this.init();
              this.hintMsg = "兑换成功";
              this.showToast();
            } else {
              this.hintMsg = res.Message;
              this.showToast();
            }
          });
      }
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 2000);
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    kExchange() {
      var count = [0, 0, 0];
      var type = this.money / 10 - 1;
      count[type] = this.num;
      var needKcoin = this.num * this.money * 10;
      var params = new this.URLSearchParam();
      params.append("ten", count[0]);
      params.append("twenty", count[1]);
      params.append("thirty", count[2]);
      params.append("total", needKcoin);
      this.$http
        .post(api.exchangeCouponByKCoin(), params.toParam())
        .then(res => {
          if (res.Result) {
            var temp = res.Data;
            //修正K币数量
            this.$http.post(api.GetMyWallet()).then(res => {
              if (res.Result) this.setWallet(res.Data);
              //刷新代金券
              this.init();
              this.hintMsg = "兑换成功!";
            });
          } else {
            this.hintMsg = res.Message + count[0] + " " + needKcoin;
          }
        });
      this.close();
      this.showToast();
    },
    refresh() {
      this.refreshing.splice(this.type, 1, true);
      setTimeout(() => {
        this.initData();
        this.refreshing.splice(this.type, 1, false);
      }, 2000);
    },
    goRule() {
      this.$router.push({ path: "/wallet/voucher/explain" });
    }
  },
  computed: {
    ...mapGetters({
      wallet: "g_walletInfo"
    })
  }
};
</script>


// WEBPACK FOOTER //
// voucher.vue?6dda8880